export default {
  data() {
    return {
      tableData: {
        coreFeatures: [
          {
            feature: this.$t('billing.zoom_whiteboard.concurrent_editable_boards_owned'),
            isString: true,
            whiteBoardBasic: '3',
            whiteBoard: 'Unlimited',
            whiteBoardPlus: 'Unlimited'
          },
          {
            feature: this.$t('billing.zoom_whiteboard.zoom_cloud_storage'),
            isString: true,
            whiteBoardBasic: '25MB',
            whiteBoard: '1GB',
            whiteBoardPlus: 'Unlimited'
          },
          {
            feature: this.$t('billing.zoom_whiteboard.unlimited_canvas_with_up_to_12_pages'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.pen_and_highlighter_annotations'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.shapes_lines_connectors_and_quick_diagraming'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.rich_text_urls_notes_and_reactions'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.image_and_pdf_embed_and_cropping'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.tables_mind_maps_kanbans_and_cards'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.comments_mentions_and_notifications'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.align_distribute_rotate_group_and_lock_content'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.presence_cursors_live_editing_and_follow_along'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.frames_and_presentation_mode'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.timer'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.export_to_high_resolution_image_pdf_and_csv'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.guest_collaboration'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.sharing_roles_and_permission_management'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.microsoft_teams_and_slack_integration'),
            tooltip: this.$t('billing.zoom_whiteboard.requires_zoom_app_installation'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.templates'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.temporarily_lock_whiteboard_access'),
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.version_history_and_activity_log'),
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.shared_folders_personal_labels'),
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.jira_cloud_cards'),
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.personal_templates'),
            whiteBoardPlus: true
          },
          {
            feature: this.$t('billing.zoom_whiteboard.organizational_templates'),
            whiteBoardPlus: true
          }
        ],
        meetingsChatWebinarRooms: [
          {
            feature: this.$t('createAndShareNewOrExistingWhiteboardsInMeetingsAndWebinar'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('shareWhiteboardsInPresentationOrCollaborationMode'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('zoomWebMeetingIntegration'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('guestAndTemporaryAccessInMeetingWebinar'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('hostOwnsAllContentCreatedInMeetingAndWebinar'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('shareClaimAndJoinWhiteboardsInZoomRoom'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('meetingAndWebinarSpecificWhiteboardSettings'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          },
          {
            feature: this.$t('shareWhiteboardsWithZoomTeamChatsAndChannels'),
            tooltip: this.$t('billing.zoom_whiteboard.also_supports_create_and_share_whiteboards'),
            whiteBoardBasic: true,
            whiteBoard: true,
            whiteBoardPlus: true
          }
        ]
      },
    };
  },
  computed: {
    treeData() {
      const mapItemKey = (data, pid) =>
        data.map((item, idx) => ({
          ...item,
          id: `${pid}_${idx}`,
        }));
      return [
        {
          feature: this.$t('billing.events.plan_details.core_features'),
          id: 'coreFeatures',
          subTitle: true,
          children: mapItemKey(this.tableData.coreFeatures, 'coreFeatures'),
        },
        {
          feature: this.$t('billing.zoom_whiteboard.included_in_zoom_one_basic_and_zoom_one_pro'),
          id: 'meetingsChatWebinarRooms',
          subTitle: true,
          children: mapItemKey(this.tableData.meetingsChatWebinarRooms, 'meetingsChatWebinarRooms'),
        },
      ];
    },
  },
};
